/**
 * Vuely Global Components
 */
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import { RotateSquare2, Circle } from 'vue-loading-spinner';
import AppSectionLoader from 'Components/AppSectionLoader/AppSectionLoader';

// page title bar
import PageTitleBar from 'Components/PageTitleBar/ThePageTitleBar';

// App Card component
import AppCard from 'Components/AppCard/AppCard';

const GlobalComponents = {
  install(Vue) {
    Vue.component('appCard', AppCard);
    Vue.component('vuePerfectScrollbar', VuePerfectScrollbar);
    Vue.component('pageTitleBar', PageTitleBar);
    Vue.component('appSectionLoader', AppSectionLoader);
    Vue.component('rotateSquare2', RotateSquare2);
    Vue.component('circleSpinner', Circle);
  }
}

export default GlobalComponents
